import { createKeyedDataAsyncSlice } from '../createKeyedDataAsyncSlice';
import { getClientOrderAsync } from '../../API/clientPortal/clientOrderAPI';

export const { slice: getClientOrderSlice, asyncAction: getClientOrderAction } = createKeyedDataAsyncSlice(
  'getClientOrder',
  getClientOrderAsync,
  (orderId) => `${orderId}`
);
